import { Module } from "../ui/Module";

export class BasePage extends Module {

    constructor(parent, options) {

        super(parent, options);

        this.pageTitle = 'XXX - application error';
        this.errorDescription = 'Error description';
        this.errorRecomendation = 'Error recomendation';

    };

    // --------------------------------------------------------------------------

    _render(r, vm) {

        const page = this;

        return r.module(null, [
            r.header(null, [
                r.h4('text-ellipsis', [
                    page.pageTitle
                ]),
            ]),
            r.section(null, [
                r.p([
                    r.span({ css: 'bold', props: { '.innerHTML': page.errorDescription } }, [])
                ]),
                r.p({ props: { '.innerHTML': page.errorRecomendation } }, []),
            ]),
        ]);

    };

}
